export const fetchAnagraficaByIdentity = async ({
  isPg,
  cf,
  pIva,
  tenantId,
  apiAnagByCf,
  apiAnagByCfPG,
}) => {
  if (!isPg) {
    return apiAnagByCf.fetch({
      tenantId,
      cf: `%${cf}%`,
      nome: "%%",
      cognome: "%%",
    });
  }

  return apiAnagByCfPG.fetch({
    tenantId,
    cf: `%${cf}%`,
    pIva: `%${pIva}%`,
    denominazione: "%%",
  });
};

export const resolveTipoAnagIdByKey = async (apiTipoAnagraficaByKey, key) => {
  const response = await apiTipoAnagraficaByKey.fetch({ key });
  return response?.data?.data?.base_tipo_anagrafica?.[0]?.Id || 0;
};

export const getAnagraficaIdFromCreateResult = (result) => {
  if (result?.data?.data?.anagrafica?.length > 0) {
    return result.data.data.anagrafica[0].Id;
  }

  if (result?.id) {
    return result.id;
  }

  return null;
};
